<template>
  <div class="layout-use-of-bar-three-content">
    <div class="descriptiom-layout-use-of-bar-three-wrapper">
      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-use-of-bar-three-description">{{ layoutUseOfBarThreeDescription1 }}</p>
      </div>
    </div>
    <div
      class="layout-use-of-bar-three-card-item"
      :style="{ backgroundImage: `url(${layoutUseOfBarThreeImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LayoutsUseOfBarThreeSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutUseOfBarThreeDescription1(): string {
    return this.getElementText(10, 0)
  }

  get layoutUseOfBarThreeImageSrc(): string {
    return this.getElementMedia(10, 1)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layout-use-of-bar-three-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.title-layout-use-of-bar-three-wrapper {
  display: flex;
  align-items: center;
  padding: 3rem;
}

.layout-use-of-bar-three-title-span {
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}
.layout-use-of-bar-three-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.descriptiom-layout-use-of-bar-three-wrapper {
  padding: 2rem 0rem 1rem 0rem;
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%;  
}

.layout-use-of-bar-three-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px;
}

.layout-use-of-bar-three-card-item {
  position: relative;

  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-size: contain;
}
</style>
